<template>
  <tr>
    <td>{{ mentoria.alumno.nombre }} {{ mentoria.alumno.apellido }}</td>
    <td>{{ mentoria.mentor.nombre }} {{ mentoria.mentor.apellido }}</td>
    <td>{{ fecha(mentoria.fecha_inicio) }}</td>
    <td>
      <span v-if="mentoria.fecha_finalizacion == null"></span>
      <span v-else >{{ fecha(mentoria.fecha_finalizacion) }}</span>
    </td>
    <td><span :class="clase" class="mentoria-condicion">{{ mentoria.condicion.nombre }}</span></td>
    <td>{{ mentoria.comentario_final_mentor }}</td>
    <td>{{ mentoria.comentario_aayi }}</td>
    <td>
      <button @click="mostrarModalDatosMentoria()"  class="boton_editar_socio boton_pagos_lista ic2-information centrar_boton"></button>
      <div class="contenedor_editar_password"
        v-if="mostrarDatosMentoria"
      >
        <div class="contenedor-datos-mentoria">
          <button class="cerrar_modal" @click="cerrarModalFinalizarMentoria()">X</button>
          <div class="contenedor-respuestas" ref="modalRef">
            <h2>Formulario de Inscripción</h2>
            <p><span>&#8226;</span><b> Nombre del mentoreado</b></p>
            <p class="respuestas-mentoreado">{{ mentoria.alumno.nombre }} {{ mentoria.alumno.apellido }}</p>
            <p><span>&#8226;</span><b> ¿Hace cuanto toma clase de Yoga Iyengar?</b></p>
            <p class="respuestas-mentoreado">{{ mentoria.tiempo_toma_clase }}</p>
            <p><span>&#8226;</span><b> ¿Hace cuanto toma clases con su mentor?</b></p>
            <p class="respuestas-mentoreado">{{ mentoria.tiempo_toma_clase_mentor }}</p>
            <p><span>&#8226;</span><b> ¿Cuantas clases semanales toma?</b></p>
            <p class="respuestas-mentoreado">{{ mentoria.cuantas_clases_semanales }}</p>
            <p><span>&#8226;</span><b> ¿Toma clases en formato online o presencial con el mentor?</b></p>
            <p class="respuestas-mentoreado">{{ mentoria.formato_clase_mentor }}</p>
            <p><span>&#8226;</span><b> En caso de tomar clases regulares online con el mentor, ¿Toma clases presenciales con algún profesor certificado en su ciudad?</b></p>
            <p class="respuestas-mentoreado">{{ mentoria.clases_presenciales_ciudad }}</p>
            <p><span>&#8226;</span><b> Si la respuesta fue no, especificar por qué (aclarar si no hay profesores certificados en el lugar de residencia del mentoreado)</b></p>
            <p class="respuestas-mentoreado">{{ mentoria.porque_no }}</p>
            <p><span>&#8226;</span><b> ¿Cuantas clases semanles enseña?</b></p>
            <p class="respuestas-mentoreado">{{ mentoria.cuantas_clases_dicta }}</p>
            <p><span>&#8226;</span><b> ¿Tiene una formación anterior? Especificar</b></p>
            <p class="respuestas-mentoreado">{{ mentoria.formacion_anterior }}</p>
            <p><span>&#8226;</span><b> Observaciones y consideraciones sobre el mentoreado</b></p>
            <p class="respuestas-mentoreado">{{ mentoria.observaciones }}</p>
          </div>
        </div>
      </div>
    </td>
    <td>
      <button @click="mostrarModal(1)"  class="boton_editar_socio boton_pagos_lista icon-pencil-square-o tabla-link"></button>
      <div class="contenedor_editar_password"
        v-if="mostrarEditarCondicion"
      >
        <div class="contenedor_form_editar_mentoria">
          <button class="cerrar_modal" @click="cerrarModalFinalizarMentoria()">X</button>
          <form
            action="#"
            @submit.prevent="editarMentoria(cambio, mentoria.mentoria_id)"
            ref="modalRef"
            class="form_editar_socio"
          >
            <div class="form_section">
              <label for="condiciones_mentoria_id">Condición</label>
              <select
                name="condiciones_mentoria_id"
                id="condiciones_mentoria_id"
                class="form minimal"
                :disabled="cargando"
                v-model="cambio.condiciones_mentoria_id"
              >
                <option
                  :value="1"
                >
                  Pendiente
                </option>
                <option
                  :value="2"
                >
                  Aceptada
                </option>
                <option
                  :value="3"
                >
                  Rechazada
                </option>
              </select>
            </div>
            <div class="form_section">
              <label for="fecha_inicio">Fecha de Inicio</label>
              <input
                type="date"
                name="fecha_inicio"
                id="fecha_inicio"
                :disabled="cargando"
                v-model="cambio.fecha_inicio"
              >
            </div>
            <div class="form_section">
              <label for="comentario_aayi">Observaciones</label>
              <textarea
                name="comentario_aayi"
                id="comentario_aayi"
                :disabled="cargando"
                v-model="cambio.comentario_aayi"
              ></textarea>
            </div>
            <button type="submit">
              <span
                v-if="!cargando"
              >
                Cargar
              </span>
              <BaseLoader3 v-else
              />
            </button>
          </form>
        </div>
      </div>
    </td>
    <td>
      <!-- <button @click="mostrarModal(2)" class="boton_editar_password boton_editar_password_2">Borrar</button> -->
      <button @click="mostrarModal(2)" class="icon icon-trash-o boton_borrar_pagos_lista boton_pagos_lista tabla-link"></button>
      <div class="contenedor_editar_password"
        v-if="mostrarMensajeBorrar"
      >
        <div class="contenedor_form_borrar_direccion">
          <button class="cerrar_modal" @click="cerrarModalFinalizarMentoria()">X</button>
          <div
            class="contenedor_botones_modal_borrar_direccion"
            ref="modalRef"
          >
            <div class="contenedor_botones_modal_borrar_direccion_texto">
              <P>¿Estas seguro que deseas borrar la metoría?</P>
              <p>Mentor: {{ mentoria.mentor.nombre }} {{ mentoria.mentor.apellido }}</p>
              <p>Mentoreado: {{ mentoria.alumno.nombre }} {{ mentoria.alumno.apellido }}</p>
            </div>
            <button @click="cerrarModalFinalizarMentoria()" class="boton_cancelar boton_borrar_direccion">CANCELAR</button>
            <button @click="borrarMentoria(mentoria.mentoria_id)" class="boton_aceptar boton_borrar_direccion">SI, BORRAR</button>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
// import examenService from '../services/examen'
import BaseLoader3 from './BaseLoader3.vue'
import mentorService from '../services/mentor'
export default {
  name: 'MentoriasListaItem',
  components: {
    BaseLoader3
  },
  props: ['mentoria'],
  data: function () {
    return {
      clase: null,
      cargando: false,
      mostrarEditarCondicion: false,
      mostrarMensajeBorrar: false,
      mostrarDatosMentoria: false,
      cambio: {
        condiciones_mentoria_id: this.mentoria.condiciones_mentoria_id,
        comentario_aayi: this.mentoria.comentario_aayi,
        fecha_inicio: this.mentoria.fecha_inicio
      }
    }
  },
  methods: {
    fecha (fecha) {
      const year = fecha.slice(0, 4)
      const month = fecha.slice(5, 7)
      const day = fecha.slice(8, 10)
      return day + '/' + month + '/' + year
    },
    mostrarModalDatosMentoria () {
      console.log('eerrrr999')
      this.mostrarDatosMentoria = true
      document.addEventListener('mouseup', this.closeModalOnClickOutside)
      // Pongo el body sin scroll
      const body = document.body
      body.style.overflow = 'hidden'
    },
    mostrarModal (id) {
      if (id === 1) {
        this.mostrarEditarCondicion = true
      } else {
        this.mostrarMensajeBorrar = true
      }
      document.addEventListener('mouseup', this.closeModalOnClickOutside)
      // Pongo el body sin scroll
      const body = document.body
      body.style.overflow = 'hidden'
    },
    closeModalOnClickOutside (event) {
      const modal = this.$refs.modalRef
      if (!modal.contains(event.target)) {
        console.log('wewewwewew')
        this.cerrarModalFinalizarMentoria()
      }
    },
    cerrarModalFinalizarMentoria () {
      console.log('222tttt222')
      document.removeEventListener('mouseup', this.closeModalOnClickOutside)
      // this.mostrarFinalizarMentoria = false

      // saco el overflow del body
      const body = document.body
      body.style.overflow = 'auto'
      this.mostrarEditarCondicion = false
      this.mostrarMensajeBorrar = false
      this.mostrarDatosMentoria = false
      // this.cambio = {
      //   condiciones_mentoria_id: this.mentoria.condiciones_mentoria_id,
      //   comentario_aayi: this.mentoria.comentario_aayi,
      //   fecha_inicio: this.mentoria.fecha_inicio
      // }
      // location.reload()
    },
    editarMentoria (cambio, id) {
      if (this.cargando) {
        return null
      }
      this.cargando = true
      console.log(cambio)
      console.log(id)
      mentorService
        .editarMentoria(cambio, id)
        .then(respuesta => {
          this.cargando = false
          console.log(respuesta)
          if (respuesta.success) {
            this.cerrarModalFinalizarMentoria()
            console.log('eeetttt')
            location.reload()
            this.$emit('refrescar')
          }
        })
    },
    borrarMentoria (id) {
      if (this.cargando) {
        return null
      }
      this.cargando = true
      console.log(id)
      mentorService
        .borrarMentoria(id)
        .then(respuesta => {
          this.cargando = false
          console.log(respuesta)
          if (respuesta.success) {
            this.cerrarModalFinalizarMentoria()
            this.$emit('refrescar')
          } else {
          }
        })
    }
  },
  mounted: function () {
    switch (this.mentoria.condiciones_mentoria_id) {
      case 1:
        this.clase = 'mentoria-pendiente'
        break
      case 2:
        this.clase = 'mentoria-aceptada'
        break
      default:
        this.clase = 'mentoria-rechazada'
    }
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.cerrarModalFinalizarMentoria()
      }
    })
    // this.cambio = {
    //   condiciones_mentoria_id: this.mentoria.condiciones_mentoria_id,
    //   comentario_aayi: this.mentoria.comentario_aayi,
    //   fecha_inicio: this.mentoria.fecha_inicio
    // }
  }
}
</script>

<style>

</style>
